import React from "react";
import InvoiceEvaluatorBaseItem from "../../../../Domain/InvoiceEvaluatorBaseItem";
import TabOfDataTable from "../../../../Elements/DataTable/TabOfDataTable";
import OrderDirectionsEnum from "../../../../Enums/OrderDirectionsEnum";
import ShownPanelsEnum from "../../../../Enums/ShownPanelsEnum";
import InvoiceEvaluatorBaseService from "../../../../Services/InvoiceEvaluatorBaseService";
import InvoiceEvaluatorSearchParams from "./InvoiceEvaluatorSearchParams";

export default class InvoiceEvaluatorComponent extends React.Component {
  static defaultProps = {
    exportPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new InvoiceEvaluatorSearchParams(props.exportPaymentId),
      shownPanel: ShownPanelsEnum.None,
    };
    this.startSearch = this.startSearch.bind(this);
  }

  componentDidMount() {}

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className="contentwrapper">
        <TabOfDataTable
          type={InvoiceEvaluatorBaseItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={InvoiceEvaluatorBaseService.GetListBySearching}
          convertDBItemsFunction={InvoiceEvaluatorBaseService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          searchParamsType={InvoiceEvaluatorSearchParams}
          showSearchStrip={false}
          clickOnStartSearch={this.startSearch}
          errorCode="IEC43"
        />
      </div>
    );
  }
}
